import { render, staticRenderFns } from "./BookMarkedMission.vue?vue&type=template&id=24e949f5&scoped=true&"
import script from "./BookMarkedMission.vue?vue&type=script&lang=js&"
export * from "./BookMarkedMission.vue?vue&type=script&lang=js&"
import style0 from "./BookMarkedMission.vue?vue&type=style&index=0&id=24e949f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e949f5",
  null
  
)

export default component.exports